// Module
var code = "<div id=\"V-BF3CB3D9-A496-4EAD-8ADA-A6E12D3E2D5A\" data-b-class-allowhorizontal=\"{Binding horizontal}\" data-b-class-beginside=\"{Binding beginside}\" data-b-class-allowvertical=\"{Binding vertical}\" data-b-content=\"{Binding content}\"> </div> ";
// Exports
export default code;